

















































































































































import { Component, Prop, Watch, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwTransitionExpand } from '../sw-transition';
import SwContentToolbarFilterBlock from './sw-content-toolbar-filter-block.vue';
import { ContentToolbarExpandFilterBlock, ProvidedToolbarParam } from './types';
import { utilService } from '../util-service';
import { SwScrollView } from '../sw-scroll-view';

const cssPrefix = 'sw-content-toolbar-expand';
const i18nPathPrefix = 'libShared.SwContentToolbarExpand';

@Component({
  components: {
    SwContentToolbarFilterBlock,
    SwTransitionExpand,
    SwScrollView,
  },
})
export default class SwContentToolbarExpand extends SwExtendedVue {
  @Prop({ type: Array })
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] | undefined;

  @Prop({ type: Boolean, default: true })
  visible: boolean;

  @Inject()
  toolbarParam: ProvidedToolbarParam;

  cssPrefix = cssPrefix;
  i18nPathPrefix = i18nPathPrefix;

  visibleRowNumber: number = 1;

  hasSlot(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.length > 0;
  }

  showMoreTrigger(): boolean {
    return !this.hasSlot() && !!this.filterBlockGrid && this.visibleRowNumber < this.filterBlockGrid.length;
  }

  onClickMore() {
    if (this.filterBlockGrid && this.visibleRowNumber < this.filterBlockGrid.length) {
      this.visibleRowNumber += 1;
    }
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (val) {
      this.visibleRowNumber = 1;
    }
  }
}
